import { createStyles } from '@asuikit/styles';

export default createStyles(() => ({
  overlay: {},
}));
